import * as ReactDOM from 'react-dom/client'
import 'animate.css'
import 'bootstrap5/dist/css/bootstrap.css'
import './assets/css'
import App from './app'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
